import scrollToComponent from "react-scroll-to-component";

export function utilScrollUp() {
    scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})
}

export function goBackBreadcrumb(props, isOnlyBackToCategory, productSelected) {
    if (isOnlyBackToCategory) {
        localStorage.setItem("selected_category_id", productSelected.product_category_id);
        localStorage.setItem("selected_category", productSelected.product_category_slug);
        localStorage.setItem('selected_sub_category_id', 0);
        localStorage.setItem('selected_sub_category', 0);
        //experimental
        props.history.push({pathname: '/product-categories/' + productSelected.product_category_slug});
    } else {
        localStorage.setItem("selected_category_id", productSelected.product_category_id);
        localStorage.setItem("selected_category", productSelected.product_category_slug);
        localStorage.setItem('selected_sub_category_id', productSelected.product_sub_category_id);
        localStorage.setItem('selected_sub_category', productSelected.product_sub_category_slug);
        if (productSelected.product_sub_category_slug === 0) {
            productSelected.product_sub_category_slug = '';
        }
        //experimental
        props.history.push({
            pathname: '/product-categories/' + productSelected.product_category_slug + '/' + productSelected.product_sub_category_slug
        });
    }
}

export function flattenMessages(nestedMessages, prefix = '') {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        let value = nestedMessages[key];
        let prefixedKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }
        return messages;
    }, {});
}